// Table cell colors
export const cellColors = {
  default: {
    color: 'rgb(50, 48, 44)',
    backgroundColor: 'rgba(227, 226, 224, 0.5)',
  },
  gray: {
    color: 'rgb(50, 48, 44)',
    backgroundColor: 'rgb(227, 226, 224)',
  },
  brown: {
    color: 'rgb(68, 42, 30)',
    backgroundColor: 'rgb(238, 224, 218)',
  },
  orange: {
    color: 'rgb(73, 41, 14)',
    backgroundColor: 'rgb(250, 222, 201)',
  },
  yellow: {
    color: 'rgb(64, 44, 27)',
    backgroundColor: 'rgb(253, 236, 200)',
  },
  green: {
    color: 'rgb(28, 56, 41)',
    backgroundColor: 'rgb(219, 237, 219)',
  },
  blue: {
    color: 'rgb(24, 51, 71)',
    backgroundColor: 'rgb(211, 229, 239)',
  },
  purple: {
    color: 'rgb(65, 36, 84)',
    backgroundColor: 'rgb(232, 222, 238)',
  },
  pink: {
    color: 'rgb(76, 35, 55)',
    backgroundColor: 'rgb(245, 224, 233)',
  },
  red: {
    color: 'rgb(93, 23, 21)',
    backgroundColor: 'rgb(255, 226, 221)',
  },
};

export const colorStyle = {
  default: {},
  gray: {
    color: 'rgb(120, 119, 116)',
    fill: 'rgb(145, 145, 142)',
  },
  brown: {
    color: 'rgb(159, 107, 83)',
    fill: 'rgb(187, 132, 108)',
  },
  orange: {
    color: 'rgb(217, 115, 13)',
    fill: 'rgb(215, 129, 58)',
  },
  yellow: {
    color: 'rgb(203, 145, 47)',
    fill: 'rgb(203, 148, 51)',
  },
  green: {
    color: 'rgb(68, 131, 97)',
    fill: 'rgb(108, 155, 125)',
  },
  blue: {
    color: 'rgb(51, 126, 169)',
    fill: 'rgb(91, 151, 189)',
  },
  purple: {
    color: 'rgb(144, 101, 176)',
    fill: 'rgb(167, 130, 195)',
  },
  pink: {
    color: 'rgb(193, 76, 138)',
    fill: 'rgb(205, 116, 159)',
  },
  red: {
    color: 'rgb(212, 76, 71)',
    fill: 'rgb(225, 111, 100)',
  },
  gray_background: {},
  brown_background: {
    backgroundColor: 'rgb(244, 238, 238)',
  },
  orange_background: {
    backgroundColor: 'rgb(251, 236, 221)',
  },
  yellow_background: {
    backgroundColor: 'rgb(251, 243, 219)',
  },
  green_background: {
    backgroundColor: 'rgb(237, 243, 236)',
  },
  blue_background: {
    backgroundColor: 'rgb(231, 243, 248)',
  },
  purple_background: {
    backgroundColor: 'rgba(244, 240, 247, 0.8)',
  },
  pink_background: {
    backgroundColor: 'rgba(249, 238, 243, 0.8)',
  },
  red_background: {
    backgroundColor: 'rgb(253, 235, 236)',
  },
};
